module.exports = __webpack_public_path__ + "static/media/welcome-illustration.4fcad17f.svg";